export default function initSearchBar(): void {
  const searchButton = document.querySelector('.js-search-button') as HTMLButtonElement
  const searchBar = document.querySelector('.js-search-bar') as HTMLElement
  const searchInput = document.querySelector('#search') as HTMLInputElement

  if (!searchButton || !searchBar) return

  let isOpen = false

  const toggleSearchBar = (): void => {
    isOpen = !isOpen

    if (isOpen) {
      searchBar.classList.remove('hidden')
      searchInput?.focus()
      searchButton.setAttribute('aria-expanded', 'true')
    } else {
      searchBar.classList.add('hidden')
      searchButton.setAttribute('aria-expanded', 'false')
    }
  }

  const closeSearchBar = (): void => {
    if (isOpen) {
      isOpen = false
      searchBar.classList.add('hidden')
      searchButton.setAttribute('aria-expanded', 'false')
    }
  }

  // Toggle search bar on button click
  searchButton.addEventListener('click', toggleSearchBar)

  // Close search bar on escape key
  document.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      closeSearchBar()
    }
  })

  // Close search bar when clicking outside
  document.addEventListener('click', (event: Event) => {
    const target = event.target as HTMLElement
    if (isOpen && !searchBar.contains(target) && !searchButton.contains(target)) {
      closeSearchBar()
    }
  })

  // Initialize aria-expanded attribute
  searchButton.setAttribute('aria-expanded', 'false')
}
